import React from "react";
import Monitoreo from "./Monitoreo.react";
var url = new URL(window.location.href);
function  MonitoreoPage() {
    return (
      <Monitoreo mtipo={ parseInt(url.searchParams.get("mtipo")) }  tipoGps={ parseInt(url.searchParams.get("gpsTipo")) } />
    )
}
export default MonitoreoPage;
